import { useNavigate } from 'react-router-dom'
import type { Nation, GovernmentType, ElectoralSystem } from '@/types'
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card'

interface NationCardProps {
  nation: Nation
}

const governmentLabels: Record<GovernmentType, string> = {
  parliamentary: 'Parliamentary',
  semi_presidential: 'Semi-Presidential',
  presidential: 'Presidential',
}

const electoralLabels: Record<ElectoralSystem, string> = {
  nationwide_pr: 'Nationwide PR',
  regional_pr: 'Regional PR',
  mixed: 'Mixed',
}

export function NationCard({ nation }: NationCardProps) {
  const navigate = useNavigate()

  return (
    <Card
      className="cursor-pointer transition-shadow hover:shadow-md"
      onClick={() => navigate(`/nations/${nation.id}`)}
    >
      <CardHeader>
        <CardTitle>{nation.name}</CardTitle>
        <CardDescription>Click to view nation details</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-1 text-sm">
          <div>
            <span className="text-muted-foreground">Government:</span>{' '}
            <span className="font-medium">{governmentLabels[nation.government_type]}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Electoral System:</span>{' '}
            <span className="font-medium">{electoralLabels[nation.electoral_system]}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Max Parties:</span>{' '}
            <span className="font-medium">{nation.max_parties}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
